<script type="text/jsx">
import Tile from '@/components/tile';
import FoldAble from '@/components/foldable';
import {
  planTypes,
  trackingPlanTypes,
  isEventSaasOrEventSassCore
} from '@/common/constants';
import { mapGetters } from 'vuex';
import { get, orderBy } from 'lodash';
import plansMixin from '@/plans/mx/plan';
import { planUnitMap, getPlanUnitWithCycle } from '@/common/product-unit';
import { getPlanUnitWithQuantity } from '@/common/product-unit';

export default {
  name: 'ConfigBase',
  mixins: [plansMixin],
  components: { Tile, FoldAble },
  props: {
    capacityUnit: {
      type: String,
      default: 'billing.attendees'
    }
  },
  data() {
    return {
      logo: '',
      title: '',
      planType: '',
      orderByKey: 'amount',
      isExpanded: true,
      configDescription: '',
      showLearnMore: true,
      unit: planUnitMap.license,
      titleAriaHidden: false,
      // FREE TRIAL
      isOnlineFreeTrial: false,
      trialDays: undefined
    };
  },
  computed: {
    ...mapGetters(['getTypeGroupSelectedPlans']),
    capacityUnitCompData() {
      return isEventSaasOrEventSassCore(this.planType) ? 'billing.attendees' : 'billing.participants';
    },
    selectedPlans() {
      return this.getTypeGroupSelectedPlans[this.planType];
    },
    hasSelectedPlan() {
      return this.selectedPlans?.length > 0;
    },
    orderSelectedPlans() {
      return orderBy(this.selectedPlans, [this.orderByKey]);
    },
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
  },
  mounted() {
    this.$context.$on('collapse-plan-card', this.collapseCard);
  },
  methods: {
    showPlanDetailDialog() {
      this.$emit('view-details');
    },
    learnMore() {
      this.$emit('learn-more');
    },
    onExpand(isExpanded) {
      this.isExpanded = isExpanded;
    },
    collapseCard() {
      this.onExpand(false);
    },
    mx_renderHeadLeft() {
      return <div class="opc-zm-base-card__head-left">
        <img src={this.logo} class="opc-zm-base-card__logo" alt={`${this.title}+' Icon'`} tabindex="-1" />
      </div>;
    },
    mx_renderHeadRight() {
      return <div class="opc-zm-base-card__head-right">
        {this.mx_renderTitle()}
        {this.mx_renderSelectedList()}
        {this.mx_renderDetailBtn()}
      </div>
    },
    mx_renderTitle() {
      const isShowCheckIcon = this.hasSelectedPlan;

      return <h1 class="opc-zm-base-card__name text-capitalize">
        {this.title}
        {isShowCheckIcon ? <i check-icon class="zm-icon-success main-icon" aria-hidden="true" /> : null}
      </h1>;
    },
    mx_renderHead() {
      return this.$slots.head ?
        this.$slots.head :
        <div slot="head" class="opc-zm-base-card__head">
          {this.mx_renderHeadLeft()}
          {this.mx_renderHeadRight()}
        </div>;
    },
    mx_renderDetailBtn() {
      const isShowBtn = this.showPlanDetails && this.isExpanded;
      return <div class="opc-zm-base-card__view-detail-button">
        {isShowBtn ?
          (this.$slots.detailBtn ?
            this.$slots.detailBtn :
          <zm-button class="opc-zm-base-card__link " type="link"
                     onClick={this.showPlanDetailDialog}>
            {this.planDetailsLabel || this.$t('billing.plan_details')}
          </zm-button>) :
        null}
      </div>;
    },
    mx_renderCapacity(plan) {
      if (!plan?.capacity) return;
      return <li class="opc-zm-base-card__col_capacity text-capitalize">{plan?.capacity} {this.$t(this.capacityUnitCompData)}</li>;
    },
    mx_renderLicense(plan) {
      if (!plan.cartInfo.selected_number) return;
      return <li class="text-lowercase">{`${plan.cartInfo.selected_number} ${getPlanUnitWithQuantity(this.unit)}`}</li>;
    },
    mx_renderCycle(plan) {
      const cycleLabel = getPlanUnitWithCycle(plan?.billing_cycle, this.unit);

      return <li>
            <span>
              {this.$money(plan.amount)}
              {cycleLabel}
            </span>
      </li>;
    },
    mx_renderSelectedRow(p) {
      return <ul key={p?.plan_code}>
        {this.mx_renderCapacity(p)}
        {this.mx_renderLicense(p)}
        {this.mx_renderCycle(p)}
      </ul>;
    },
    mx_renderSelectedList() {
      if (this.isExpanded) return;

      return <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" slot="collapse">
        {this.orderSelectedPlans.map((plan) => this.mx_renderSelectedRow(plan))}
      </div>;
    },
    mx_renderDivideLine() {
      return <div class="divide-line" />;
    },
    mx_renderConfigDesc() {
      return this.$slots.configDesc ?
        this.$slots.configDesc :
        <div class="opc-zm-base-card__main--desc">
          <span class="opc-zm-base-card__main--desc__content" domPropsInnerHTML={this.configDescription} />
          {this.showLearnMore ?
            <zm-button type="link" onClick={this.learnMore} class="opc-zm-base-card__main--desc__btn">
              {this.$t('billing.common.learn_more')}
            </zm-button> : null}
        </div>;
    },
    mx_renderConfig() {
      return <div class="opc-zm-base-card__main__config">
        {this.$slots.config}
      </div>;
    },
    mx_renderFooter() {
      return this.$slots.footer ? <div class="opc-zm-base-card__main__footer">
        {this.$slots.footer}
      </div> : null;
    },
    mx_renderMain() {
      return <div class="opc-zm-base-card__main">
        {this.mx_renderConfigDesc()}
        {this.mx_renderConfig()}
        {this.mx_renderFooter()}
      </div>;
    },
    mx_renderTopAlert() {
      return this.$slots.topAlert ? <div>
        {this.$slots.topAlert}
      </div> : null;
    },
    mx_renderFoldAble(children) {
      return <fold-able
        value={this.isExpanded}
        onChange={this.onExpand}
        arrow={this.hasSelectedPlan}
        edit={this.hasSelectedPlan}
        title={this.title}
        titleAriaHidden={this.titleAriaHidden}
        isRemoveWrapAriaLabelledby={true}>
        {children ?? this.$slots.default}
      </fold-able>;
    },
  },
  render() {
    return <tile class="opc-zm-base-card">
      {this.mx_renderTopAlert()}
      {this.mx_renderFoldAble([
        this.mx_renderHead(),
        this.mx_renderDivideLine(),
        this.mx_renderMain(),
      ])}
    </tile>;
  },
  watch: {
    isExpanded: {
      handler(val) {
        if (this.$context?.is.zs2ze) {
          !val && this.$tracking.buyInteraction(`product details accordion`, 'zoom events - collapse');
        } else {
          this.$tracking.addOnBuyInteraction(`${this.trackingPlanKey} accordion`, val ? 'expand' : 'collapse');
        }
      },
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/zoom-card.scss';
</style>
